module.exports = __webpack_public_path__ + "img/logo-dark-2.7de42077.png";